import { BugReportMessageType, useBugReportMutation } from '@app/data'
import { LogUtils } from '@app/utils/LogUtils'

import { reportStore } from '../store/reportStore'

export const useBugReporting = () => {
  const [bugReportMutation, { loading, error }] = useBugReportMutation()

  const reportBug = async (type: BugReportMessageType, message: string) => {
    const context = reportStore.getReportContext()

    try {
      await bugReportMutation({
        variables: { message: { context, message, type } }
      })

      return true
    } catch (e) {
      LogUtils.logError(e, 'useBugReporting', 'reportBug')

      return false
    }
  }

  return {
    loading,
    error,
    actions: {
      reportBug
    }
  }
}
